import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './NoContentLesson.module.css'; 
import noContentIllustration from '../../assets/images/no-content-lesson.png';
import { t } from '../../lib/i18n';

const NoContentLesson = () => {
  const history = useHistory();
  const location = useLocation();

  // Function to navigate to the next activity
  const goToNextActivity = () => {
    const currentPath = location.pathname.split('/');
    const currentActivityIndex = parseInt(currentPath[currentPath.length - 1], 10); // Last number in the URL
    const lessonId = parseInt(currentPath[currentPath.length - 2], 10); // Second to last number in the URL

    // Example of maximum activities limit (this can be dynamic)
    const maxActivities = 20; // Set the maximum number of activities here

    if (currentActivityIndex < maxActivities) {
      // Create the new URL for the next activity
      const nextPath = `${currentPath.slice(0, -1).join('/')}/${currentActivityIndex + 1}`;
      history.push(nextPath); // Redirect to the next activity
    } else {
      // If no next activity exists, increment the second to last number (lessonId)
      const newLessonId = lessonId + 1;
      const nextPath = `${currentPath.slice(0, -2).join('/')}/${newLessonId}/1`; // Redirect to the new lesson and first activity
      history.push(nextPath); // Redirect to the new lesson
    }
  };

  return (
    <div className={styles.container_without_lesson}>
      <div>
        <img
          className={styles.img_illustration}
          src={noContentIllustration}
          alt="No Content Available"
        />
      </div>
      <div className={styles.block_phrase}>
        <p className={styles.without_lesson_phrase}>
         {t("Oops! Parece que essa atividade não está disponível para você.")}
        </p>
        <p>
        {t("Volte para lista de lições ou clique em Pular para continuar seus estudos.")}
        </p>
        <button onClick={goToNextActivity} className={styles.next_activity_button}>
          {t("Pular")}
        </button>
      </div>
    </div>
  );
};

export default NoContentLesson;
